export default __webpack_public_path__ + "static/media/Glass_sm.43b8c6b4.jpg";